export const I18N_LOCALE_ROUTE_PREFIXES = ["/", "/seer"];

export const LOCALE_PATH_SEGMENTS = ["tw", "en"];

export const LOCALE_SEGMENT_TO_LOCALE = {
	tw: "zh-TW",
	en: "en",
};

export const LOCALE_TO_PATH_SEGMENT = {
	"zh-TW": null,
	en: "en",
};

export const DEFAULT_LOCALE = "zh-TW";
export const TW_REGION_SEGMENT = "tw";
export const LOCALE_REGION_COOKIE_KEY = "app-locale-region";

export function parseLocaleSegmentFromPath(path) {
	if (!path) return null;
	const match = path.match(/^\/(tw|en)(\/|$)/);
	return match ? match[1] : null;
}

export function parseLocaleFromPath(path) {
	const segment = parseLocaleSegmentFromPath(path);
	if (!segment) return null;
	return LOCALE_SEGMENT_TO_LOCALE[segment] || null;
}

export function stripLocalePrefix(path) {
	if (!path) return "/";
	const match = path.match(/^\/(tw|en)(\/(.*))?$/);
	if (!match) return path;
	if (!match[2]) return "/";
	return `/${match[3]}`;
}

export function isHomeRoutePath(path) {
	if (!path) return false;
	return stripLocalePrefix(path) === "/";
}

export function resolvePreferTw(options = {}) {
	const { path, region } = options;
	if (parseLocaleSegmentFromPath(path || "") === TW_REGION_SEGMENT) return true;
	return isHomeRoutePath(path || "") && region === TW_REGION_SEGMENT;
}

export function addLocalePrefix(path, locale, options = {}) {
	const { preferTw = false } = options;
	const normalized = stripLocalePrefix(path.split("?")[0].split("#")[0]) || "/";

	let segment = null;
	if (locale === "en") {
		segment = "en";
	} else if (preferTw) {
		segment = TW_REGION_SEGMENT;
	} else {
		segment = LOCALE_TO_PATH_SEGMENT[locale] ?? null;
	}

	if (!segment) return normalized;
	return `/${segment}${normalized === "/" ? "" : normalized}`;
}

export function switchLocaleInFullPath(fullPath, locale, options = {}) {
	const hashIdx = fullPath.indexOf("#");
	const hash = hashIdx >= 0 ? fullPath.slice(hashIdx) : "";
	const pathAndQuery = hashIdx >= 0 ? fullPath.slice(0, hashIdx) : fullPath;
	const queryIdx = pathAndQuery.indexOf("?");
	const query = queryIdx >= 0 ? pathAndQuery.slice(queryIdx) : "";
	const pathname = queryIdx >= 0 ? pathAndQuery.slice(0, queryIdx) : pathAndQuery;
	return addLocalePrefix(pathname, locale, options) + query + hash;
}

export function isI18nLocaleRoute(path) {
	if (!path) return false;
	const normalized = stripLocalePrefix(path.split("?")[0].split("#")[0]);
	return I18N_LOCALE_ROUTE_PREFIXES.some(
		prefix => normalized === prefix || normalized.startsWith(`${prefix}/`)
	);
}

export function shouldRegisterLocalizedRoute(path) {
	if (!path) return false;
	if (path.includes(":")) return true;
	return isI18nLocaleRoute(path);
}
